export const name = 'dashboards'

export const REFRESH_RECENT_ANSWERS = `${name}/REFRESH_RECENT_ANSWERS`
export const REFRESH_RECENT_ANSWERS_SUCCESS = `${name}/REFRESH_RECENT_ANSWERS_SUCCESS`
export const REFRESH_RECENT_ANSWERS_ERROR = `${name}/REFRESH_RECENT_ANSWERS_ERROR`
